import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { pairwise } from 'rxjs/operators';
import InventoryManagementService from '../inventory-unpublished-batch/inventory-management.service'
import { NgIf } from '@angular/common';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CustomInventoryContentComponent } from '../custom-inventory-content/custom-inventory-content.component';

@Component({
    selector: 'app-inventory-unpublished-batch',
    templateUrl: './inventory-unpublished-batch.component.html',
    styleUrls: ['./inventory-unpublished-batch.component.scss'],
    imports: [NgIf, InfiniteScrollDirective, CustomInventoryContentComponent]
})
export class InventoryUnpublishedBatchComponent implements OnInit, OnChanges {
  browseType: string;
  @Input() inventoryTab: any;
  @Input() searchValue: any;
  inventoryData: any = [];
  publishedData = [];
  unpublishedData: any = [];
  archivedData: any = [];
  query: string = null;
  //@Input() productInfo: any;
  productInfo = {headerColor: {'bgColor':true}, shortDescription: 'JIMF',name:'Yandi Fine Ore17'};
  port = {name:'Tangshan Caofeidian'};
  constructor(private inventoryManagementService:InventoryManagementService) { 
    
  } 
  @Input() grid: boolean;
  @Input() list: boolean;
  @Input() sortData: any;
  //@Input() productInfo: any;
  enableLoader: boolean;
  reachedToEnd = false;
  loaderShow = false;
  page = 0;
  nextProducts: any;
  ngOnInit(): void {
    this.enableLoader = true;
    this.browseType = 'publishedBatches'
    this.inventoryManagementService.filterInput$.pipe(pairwise()).subscribe(([previous,current])=>{
      if(previous != current){
        if(current != null) {
          this.query = current;
          this.enableLoader = true;
          this.searchValue = this.searchValue?.trim();
          this.page = 0;
          this.reachedToEnd = false;
          this.inventoryManagementService.getInventoryData(this.page,this.sortData,this.searchValue=null,current).subscribe((data:any) => { 
            this.enableLoader = false;
            this.inventoryData = data.products;
            this.publishedData = [];
            this.unpublishedData = [];
            this.archivedData = [];
            this.getPublishedData();
          });
        }else{
          this.enableLoader = true;
          this.searchValue = this.searchValue?.trim();
          this.page = 0;
          this.reachedToEnd = false;
          this.query = null;
          this.inventoryManagementService.getInventoryData(this.page,this.sortData,this.searchValue=null).subscribe((data:any) => { 
            this.enableLoader = false;
            this.inventoryData = data.products;
            this.publishedData = [];
            this.unpublishedData = [];
            this.archivedData = [];
            this.getPublishedData();
          });
        }
      }
    })
    this.inventoryManagementService.getInventoryData(this.page,this.sortData,this.searchValue=null).subscribe((data:any) => { 
      this.enableLoader = false;
      this.inventoryData = data.products;
      this.getPublishedData();
    });
  }
  processUrlParams(query: any): any{
    return ":"+query.substring(1).split(/:(.+)/)[1].replaceAll("portName","portId");
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.sortData && changes?.sortData.previousValue!= undefined || (changes?.searchValue?.currentValue?.trim().length >= 3 && changes?.searchValue?.currentValue?.trim() != '') || changes?.searchValue?.currentValue == ''){
      if(changes?.searchValue?.currentValue == ''){
        this.query = null;
      }
      this.page = 0;
      this.reachedToEnd = false;
      this.enableLoader = true;
      this.browseType = 'publishedBatches'
      this.searchValue = this.searchValue?.trim();
      this.inventoryManagementService.getInventoryData(this.page,this.sortData,this.searchValue,this.query).subscribe((data:any) => { 
      this.enableLoader = false;
      this.inventoryData = data.products;
      this.publishedData = [];
      this.unpublishedData = [];
      this.archivedData = [];
      this.getPublishedData();
    });
    }
  }
  onScrollGrid(): any {
    if (!this.reachedToEnd){
      this.loaderShow = true;
      setTimeout(() => {
        this.loadNextDataInventoryList();
      },1000);
    }
  }

  loadNextDataInventoryList(): any {
    this.page += 1;
    if (!this.reachedToEnd){
      this.searchValue=this.searchValue?.trim()
      this.inventoryManagementService.getInventoryData(this.page,this.sortData,this.searchValue,this.query).subscribe((data: any)=>{
        this.loaderShow = false;
        this.nextProducts = data;
        if(this.page > data.pagination.totalPages-1){
          this.reachedToEnd = true;
        }
        if(this.nextProducts.products){
          this.inventoryData = this.inventoryData.concat(this.nextProducts.products);
          this.loadNextData();
        }
      });
    }else{
      this.loaderShow = false;
    }
  }
  loadNextData(){
    if(this.nextProducts.products){
      this.nextProducts.products.map(val=>{
        // if(val.status === 'Published'){
        if(val.status === 'approved'){
            this.publishedData.push(val)
        }else if(val.status === 'check'){
            this.unpublishedData.push(val)
        }else if(val.status === 'unapproved'){
            this.archivedData.push(val)
        }
    })
    }
  }
  getPublishedData() {
    if(this.inventoryData){
      this.inventoryData.map(val=>{
            // if(val.status === 'Published'){
            if(val.status === 'approved'){
                this.publishedData.push(val)
            }else if(val.status === 'check'){
                this.unpublishedData.push(val)
            }else if(val.status === 'unapproved'){
                this.archivedData.push(val)
            }
        })
    }
}

}
